<div>
  <div>
    <b>Steps</b>
  </div>
  <div class='d-flex mt-2 w-100 btn-container'
    style="flex-direction: column; justify-content: space-between; align-items: center; ">
    <div class="w-100 l-panel" style="overflow: auto; height: 80%;">
      <ng-container *ngIf="hasStages">
        <div class="d-flex flex-column align-items-center">
          <ng-container *ngFor="let stage of stages; let i = index; let isLast = last;" class="m-auto w-100">
            <button data-testid="auto-progress-panel-button-1" (click)="selectStage(stage.campaign_stage_id)" class="steps-btn text-left flex-grow-1"
              [ngClass]="{'btn-active': isStageActive(stage.campaign_stage_id) }">
              <div>
                <div class="d-flex align-items-center"
                  style="line-height: 1.5; width: 100%; ">
                  <!-- <div style="width: 100%; display: inline-flex;"> -->
                    <span>
                      <i class="fa-sharp fa-circle-check fa-xl mr-2"
                      [ngStyle]="isInEditMode.stageId===stage.campaign_stage_id && isInEditMode.editMode ? { color: '#d9d9d9' } : { color: '#229300' }"></i>
                    </span>
                    <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; max-width: 96%;" matTooltip="{{'Step ' + (i+1) + ' - ' + stage.stage_name }}" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                    >
                      {{'Step ' + (i+1) + ' - ' + stage.stage_name }}
                    </div>
                  <!-- </div> -->
                  <button data-testid="auto-progress-panel-button-2" class="ats-btn btn-break ml-auto" style="border: none; background: none; " type="button"
                    id="stageActionDropdown" appDropdownToggle aria-haspopup="true" aria-expanded="false"
                    *ngIf="canSwitch && !isInEditMode.editMode && stage && i!=0">
                    <i class="fa-solid fa-ellipsis-vertical "></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="stageActionDropdown"
                    style="width: fit-content; min-width: 0px; padding: 0px;">
                    <a data-testid="auto-progress-panel-a-1" class="dropdown-item f-14" routerLinkActive="active" style="color: #484b59; padding: 8px 16px;"
                      (click)="deleteCampaignStage(stage.campaign_stage_id, i)">
                      <i class="fa-solid fa-trash mr-1" style="color: #cd0f0f;"></i>
                      <span style="width: fit-content;">
                        Delete
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </button>
            <div class="vertical-line" *ngIf="!isLast"></div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="!readOnly && !hasStages && !isInEditMode.editMode">
        <button data-testid="auto-progress-panel-button-3" class="btn-trms-medium m-auto w-100" style="width: 452px; height: 56px;" (click)="addNewStage()">+
          First email</button>
      </ng-container>
      <ng-container *ngIf="canSwitch && !isInEditMode.editMode && stage ">
        <div class="d-flex flex-column align-items-center">
          <div class="vertical-line" *ngIf="!isLast"></div>
          <button data-testid="auto-progress-panel-button-4" class="steps-btn" id="follow-up-btn"
            (click)="addNewStage()"
            [disabled]="isMaxStagesReached"
            [style.color]="isMaxStagesReached ? '#aaa' : '#2e93a1'"
            [style.cursor]="isMaxStagesReached ? 'not-allowed' : 'pointer'"
            style="font-weight:600;">
            <span *ngIf="!isMaxStagesReached">+ Follow up email</span>
            <span *ngIf="isMaxStagesReached"><i class="fas fa-lock mr-1" style="font-size:11px;"></i>Max {{ MAX_STAGES }} stages reached</span>
          </button>
        </div>
      </ng-container>
    </div>


    <div class="d-flex flex-wrap justify-content-center w-100" *ngIf="!readOnly && canSwitch && stages && stages.length">
      <button data-testid="auto-progress-panel-button-5" class="start-cmpn mb-2" (click)="openConfirmationModal()" [class.disabled]="isInEditMode.editMode"
        [disabled]="isInEditMode.editMode">Start campaign</button>
      <span class="f-12 text-center mt-1" style="color: #888;"><i class="fa-sharp fa-solid fa-circle-info mr-1" style="color: #ffc710;"></i>Steps cannot be added or edited once the campaign leaves Draft state</span>
    </div>
    <div class="d-flex flex-wrap justify-content-center w-100" *ngIf="!readOnly && !canSwitch">
      <button data-testid="auto-progress-panel-button-6" class="start-cmpn mb-2" (click)="goToTargetListing()" [class.disabled]="isInEditMode.editMode"
        [disabled]="isInEditMode.editMode">Save and Continue</button>
    </div>
  </div>
</div>

<ng-template #confirmTemplateModal>
  <div class="confirm-modal-body">

    <!-- Icon -->
    <div class="confirm-modal-icon">
      <i class="fa-solid fa-sensor-triangle-exclamation" style="color: #e9ac0d; font-size: 36px;"></i>
    </div>

    <!-- Primary message -->
    <p class="confirm-modal-title">
      Once a campaign leaves <strong>Draft</strong> state, steps can no longer be added, edited, or deleted.
    </p>

    <!-- Active campaign limit warning -->
    <div *ngIf="currentActiveCampaignCount > 0" class="confirm-modal-notice">
      <div class="confirm-modal-notice-header">
        <i class="fas fa-pause-circle mr-2" style="color: #e6a700;"></i>
        You have <strong>{{ currentActiveCampaignCount }}</strong> active campaign(s) running — this campaign will be saved in <strong>Paused</strong> state.
      </div>
      <p class="confirm-modal-notice-body">
        You can still add candidates to it. To activate this campaign, pause an active one from the
        <a data-testid="auto-progress-panel-a-2" routerLink="/email-campaign/campaign-listing" (click)="closeModal()">listing screen</a>.
      </p>
    </div>

  </div>

  <div class="confirm-modal-footer">
    <button data-testid="auto-progress-panel-button-7" class="btn-trms-white" (click)="closeModal()">Cancel</button>
    <button data-testid="auto-progress-panel-button-8" class="btn-trms-small" (click)="onStartCampaignClick()">
      {{ currentActiveCampaignCount > 0 ? 'Save as Paused' : 'Start' }}
    </button>
  </div>
</ng-template>
